import initialStepValidation from 'reducers/work-order/close-step-validation/initialStepValidation';

export default(state, orderId) => {

    let currentValidation = state.getIn(['workOrderDetails', orderId, 'orderClose', 'details', 'stepValidation']) || initialStepValidation;

    const orderStatus = state.getIn([
        'workOrderDetails',
        orderId,
        'orderClose',
        'details',
        'closeOrderRequest',
        'orderStatus'
    ]);

    if (orderStatus) {

        currentValidation = currentValidation.setIn([
            'orderStatus', 'isValid'
        ], true).setIn([
            'orderStatus', 'message'
        ], null);
    }

    return currentValidation;

};



// WEBPACK FOOTER //
// ./src/reducers/work-order/close-step-validation/orderStatusValidator.js